import React from 'react'
import { IEdiMessage } from 'types/graphqlTypes'
import { formatOptionLabel } from '../../EdiSelfServiceOutbound/hooks/useTransactionSets'

export const TransactionSetDescription = ({ ediMessageType }: { ediMessageType: IEdiMessage }) => {
  return (
    <>
      {formatOptionLabel({
        transactionSet: ediMessageType.transactionSet,
        transactionSetSubtype: ediMessageType.transactionSetSubtype,
      })}
    </>
  )
}
